export const ANALYTICS_SOURCE_NAME = 'workItemPermissionError';
